import { Timestamp } from 'firebase/firestore';

export enum SubscriptionType {
  MONTHLY = 'monthly',
  YEARLY = 'yearly'
}

export enum RequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

export interface SubscriptionRequest {
  id: string;
  userId: string;
  userFullName: string;
  userPhoneNumber: string;
  userEmail: string;
  subscriptionType: SubscriptionType;
  requestedAt: Date;
  status: RequestStatus;
  processedAt?: Date;
  processedBy?: string;
  notes?: string;
}

export interface SubscriptionRequestDocumentData {
  userId: string;
  userFullName: string;
  userPhoneNumber: string;
  userEmail: string;
  subscriptionType: string;
  requestedAt: Date | Timestamp;
  status: string;
  processedAt?: Date | Timestamp;
  processedBy?: string;
  notes?: string;
}

const toDate = (value?: Date | Timestamp): Date | undefined => {
  if (!value) return undefined;
  return value instanceof Timestamp ? value.toDate() : new Date(value);
};

export class SubscriptionRequestModel {
  static fromFirestore(id: string, data: SubscriptionRequestDocumentData): SubscriptionRequest {
    return {
      id,
      userId: data.userId,
      userFullName: data.userFullName,
      userPhoneNumber: data.userPhoneNumber,
      userEmail: data.userEmail,
      subscriptionType: data.subscriptionType as SubscriptionType,
      requestedAt: toDate(data.requestedAt) ?? new Date(),
      status: data.status as RequestStatus,
      processedAt: toDate(data.processedAt),
      processedBy: data.processedBy,
      notes: data.notes
    };
  }
}
